const getEnvironmentPrefix = hostname => {
  if (hostname?.includes('local')) {
    return { environment: 'local.', protocol: 'http' };
  }

  if (hostname?.includes('staging')) {
    return { environment: 'staging.', protocol: 'https' };
  }

  return { environment: '', protocol: 'https' };
};

export const generateURL = (siteName, slug) => {
  const environmentName = `${process.env.REACT_APP_ORION_ENV}`;

  if (environmentName === 'local') {
    return `http://local.${siteName}/${slug}`;
  }

  if (environmentName === 'staging') {
    return `https://staging.${siteName}/${slug}`;
  }

  return `https://${siteName}/${slug}`;
};

export const generateCampaignLink = (_id, campaignRoute) => {
  if (typeof window === 'undefined') return undefined;

  const { environment, protocol } = getEnvironmentPrefix(window.location.hostname);

  switch (campaignRoute) {
    case 'freebook':
      return `${protocol}://${environment}earlybirdbooks.com/${campaignRoute}/index.html?q=${_id}`;
    case 'giveaway':
      return [
        `${protocol}://${environment}earlybirdbooks.com/${campaignRoute}?q=${_id}`,
        `${protocol}://${environment}the-line-up.com/${campaignRoute}?q=${_id}`,
        `${protocol}://${environment}theportalist.com/${campaignRoute}?q=${_id}`,
        `${protocol}://${environment}explorethearchive.com/${campaignRoute}?q=${_id}`,
        `${protocol}://${environment}alovesotrue.com/${campaignRoute}?q=${_id}`,
        `${protocol}://${environment}murder-mayhem.com/${campaignRoute}?q=${_id}`,
      ];
    default:
      return `${protocol}://${environment}earlybirdbooks.com/${campaignRoute}?q=${_id}`;
  }
};

export const isValidURL = url => {
  if (!url?.trim()) return false;

  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
};
